declare const BASE_URL: string;

export function initLoginForm() {

    const loginBox = document.querySelector(".login-box") as HTMLDivElement;
    
    const statusBadge = document.getElementById("status-badge") as HTMLSpanElement;

    const loginBtn = document.getElementById("login-btn") as HTMLButtonElement;
    const logoutBtn = document.getElementById("logout-button") as HTMLButtonElement;
    const refreshButton = document.getElementById("refresh-button") as HTMLButtonElement;

    const username = (document.getElementById("username") as HTMLInputElement);
    const password = (document.getElementById("password") as HTMLInputElement);


    loginBox.classList.add("hidden");
    refreshButton.style.display = "none";
    logoutBtn.style.display = "none";
    loginBtn.style.display = "none";

    const savedToken = getTokenFromStorage();
    
    if (savedToken) {
        setUserStatus(true, statusBadge, loginBtn, logoutBtn, refreshButton, null);
    } else {
        setUserStatus(false, statusBadge, loginBtn, logoutBtn, refreshButton, null);
        loginBox.classList.remove("hidden");
    }

    const checkInputs = () => {
        const isLoggedIn = !!getTokenFromStorage();
        if (isLoggedIn) return;

        loginBtn.style.display = (username.value && password.value) ? "inline-block" : "none";
        refreshButton.style.display = "none";
        logoutBtn.style.display = "none";
    };
    username.addEventListener("input", checkInputs);
    password.addEventListener("input", checkInputs);

    const logout = () => {
        sessionStorage.removeItem("token");
        username.value = "";
        password.value = "";
        setUserStatus(false, statusBadge, loginBtn, logoutBtn, refreshButton, null);
        loginBox.classList.remove("hidden");
    };
    logoutBtn.addEventListener("click", logout);

    initFormSubmission(loginBtn, username, password,statusBadge, refreshButton, logoutBtn, loginBox);

}

export function getTokenFromStorage(): string | null {
    const token = sessionStorage.getItem("token");
    return token ? token : null;
}

export function getBaseUrl(): string {
    return BASE_URL;
}


function initFormSubmission(loginBtn : HTMLButtonElement, username : HTMLInputElement, password : HTMLInputElement,
        statusBadge : HTMLSpanElement, refreshButton : HTMLButtonElement, logoutBtn : HTMLButtonElement, loginBox : HTMLDivElement) {

    const form = document.getElementById("login-form") as HTMLFormElement;
    const loginSpinner = document.getElementById("login-spinner") as HTMLSpanElement;
    const loginText = document.getElementById("login-text") as HTMLSpanElement;

    form.addEventListener("submit", async (event) => {
        event.preventDefault();
        loginBtn.style.display = (username.value && password.value) ? "inline-block" : "none";
        refreshButton.style.display = "none";
        logoutBtn.style.display = "none";

        loginSpinner.classList.remove("hidden");
        loginText.textContent = "Signing in...";


        try {

            const jwt =await login(username.value, password.value);
            if(jwt) {
                sessionStorage.setItem("token", jwt);
                setUserStatus(true, statusBadge,loginBtn,logoutBtn,refreshButton, null);
                form.reset();
                loginBox.classList.add("hidden");
            }

        } catch (error) {
            setUserStatus(false, statusBadge,loginBtn,logoutBtn,refreshButton, "failed")
        } finally {
            loginSpinner.classList.add("hidden");
            loginText.textContent = "Login";
            loginBtn.style.display = (username.value && password.value) ? "inline-block" : "none";
        }
    });
}


function setUserStatus(isOnline : boolean, statusBadge : HTMLSpanElement,loginBtn : HTMLButtonElement,
                    logoutBtn : HTMLButtonElement, refreshButton : HTMLButtonElement, other : string | null) {

    statusBadge.classList.remove("hidden");
    if (isOnline) {
        statusBadge.textContent = 'Online';
        statusBadge.classList.remove('offline');
        statusBadge.classList.add('online');
        
        refreshButton.style.display = "inline-block";
        logoutBtn.style.display = "inline-block";
    } else {
        if(other == "failed") {
            statusBadge.textContent = "Login failed";
            loginBtn.style.display  = "inline-block";
        }else{
            statusBadge.textContent = 'Offline';
            loginBtn.style.display  = "none";
        }
        statusBadge.classList.remove('online');
        statusBadge.classList.add('offline');

        refreshButton.style.display = "none";
        logoutBtn.style.display = "none";
    }
}


async function login(username: string, password: string): Promise<string> {
    const baseUrl = getBaseUrl();
    const response = await fetch(`${baseUrl}/api/excel-addin/get-token`, {
        method: "POST",
        headers: {
        "accept": "application/json",
        "Content-Type": "application/json"
        },
        body: JSON.stringify(
            {
                "email": username,
                "password": password
            }
        )
    });

    const contentType = response.headers.get("content-type");

    let data: any = null;
    if (contentType && contentType.includes("application/json")) {
        data = await response.json();
    }

    if (!response.ok) {
        throw new Error(data?.message || "Invalid credentials");
    }

    if (!data?.accessToken) {
        throw new Error("Token not returned by server");
    }
    return data.accessToken;
}


export function showSessionExpiredPopup(title = "Session expired", message = "Your session has expired.<br>Please login again.",
                                    buttonText = "Reconnect") {
    const modal = document.getElementById("session-modal") as HTMLDivElement;
    const h3 = document.getElementById("session-modal-title") as HTMLHeadingElement;
    const p = document.getElementById("session-modal-message") as HTMLParagraphElement;
    const reconnectBtn = document.getElementById("reconnect-btn") as HTMLButtonElement;

    h3.textContent = title;
    p.innerHTML = message;
    reconnectBtn.textContent = buttonText;

    modal.classList.remove("hidden");

    const newBtn = reconnectBtn.cloneNode(true) as HTMLButtonElement;
    reconnectBtn.parentNode.replaceChild(newBtn, reconnectBtn);
    newBtn.addEventListener("click", () => {
        sessionStorage.clear()
        modal.classList.add("hidden");
        initLoginForm();
    });

    
}